module.exports = __webpack_public_path__ + "img/prod-4.d2b2a5c5.png";